// Product-card variant swatches: hover a swatch to preview that variant on the card image.
(() => {
  if (window.__zumiiSwatches) return;
  window.__zumiiSwatches = true;
  const cardOf = (el) => el.closest('.product-card-wrapper, .card-wrapper');
  const mainImg = (card) => card && card.querySelector('.card__media img');
  document.addEventListener('mouseover', (e) => {
    const sw = e.target.closest('.zumii-swatch');
    if (!sw) return;
    const card = cardOf(sw); const img = mainImg(card);
    if (!img || !sw.dataset.previewSrc) return;
    if (!img.dataset.zOrigSrc) { img.dataset.zOrigSrc = img.src; img.dataset.zOrigSrcset = img.srcset; }
    img.srcset = sw.dataset.previewSrcset; img.src = sw.dataset.previewSrc;
    card.classList.add('zumii-sw-active');
    card.querySelectorAll('.zumii-swatch').forEach((s) => s.classList.toggle('is-active', s === sw));
  });
  document.addEventListener('mouseout', (e) => {
    const box = e.target.closest('[data-zumii-swatches]');
    if (!box || box.contains(e.relatedTarget)) return;
    const card = cardOf(box); const img = mainImg(card);
    if (img && img.dataset.zOrigSrc) { img.srcset = img.dataset.zOrigSrcset; img.src = img.dataset.zOrigSrc; }
    card?.classList.remove('zumii-sw-active');
    card?.querySelectorAll('.zumii-swatch.is-active').forEach((s) => s.classList.remove('is-active'));
  });
})();
